/** Brand & utility icons. SVGs inlined for zero-runtime cost. */

export function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      aria-hidden="true"
      width="20"
      height="20"
    >
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3C33.7 32.6 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="m6.3 14.7 6.6 4.8C14.6 16 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 9.9-2 13.5-5.2l-6.2-5.2C29.2 35 26.7 36 24 36c-5.2 0-9.6-3.4-11.2-8l-6.5 5C9.5 39.5 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.7l6.2 5.2C39.7 36 44 30.5 44 24c0-1.2-.1-2.4-.4-3.5z"
      />
    </svg>
  );
}


export function MailIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="20"
      height="20"
      aria-hidden="true"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  );
}

type LineIconProps = { className?: string };
const LINE = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function GlobeIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z" />
    </svg>
  );
}

export function ChevronDownIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE} strokeWidth={2}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function CheckIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE} strokeWidth={2.4}>
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
  );
}

export function PaperPlaneIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
      <path d="M21 3L3 10.5l7 2.5 2.5 7L21 3z" />
      <path d="M10 13l4.5-4.5" />
    </svg>
  );
}

export function BoltIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE} strokeWidth={2}>
      <path d="M13 3L5 13.5h6L10 21l8-10.5h-6L13 3z" />
    </svg>
  );
}

export function InboxIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
      <path d="M4 13l2.5-7h11L20 13v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
      <path d="M4 13h4.5l1.5 2.5h4l1.5-2.5H20" />
    </svg>
  );
}

export function ReplyIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
      <path d="M10 8L5 12l5 4" />
      <path d="M5 12h9a5 5 0 0 1 5 5v1" />
    </svg>
  );
}

export function ListCheckIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
      <path d="M4 6.5l1.5 1.5L8 5.5" />
      <path d="M4 12.5l1.5 1.5L8 11.5" />
      <path d="M4 18.5l1.5 1.5L8 17.5" />
      <path d="M11 7h9M11 13h9M11 19h9" />
    </svg>
  );
}

export function HandIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
      <path d="M8 12V6a1.5 1.5 0 0 1 3 0v5" />
      <path d="M11 11V4.5a1.5 1.5 0 0 1 3 0V11" />
      <path d="M14 11V6a1.5 1.5 0 0 1 3 0v7c0 4-2.5 7-6.5 7S5 17.5 4 15l-1-2.5a1.5 1.5 0 0 1 2.7-1.3L8 14" />
    </svg>
  );
}

export function ShieldIcon({ className }: LineIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
      <path d="M12 3l7 3v5c0 5-3.2 8.6-7 10-3.8-1.4-7-5-7-10V6z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}
